import { Component } from "react";
import { Modal as ModalComponent } from "views/components";
import TeamTemplateSizeForm from "./TeamTemplateSizeForm";
import {
  SizeFormErrors,
  SizeFormState,
  buildSizeInput,
  emptySizeFormState,
  isSizeFormValid,
  validateSizeForm
} from "./teamTemplateSizeFormUtils";
import { TeamTemplateSizeInput } from "state/entities/teamTemplateSizes/teamTemplateSizesActions";
import style from "./style.module.css";

const Modal = ModalComponent as any;

interface AddTeamTemplateSizeModalProps {
  isOpen: boolean;
  teamId: string;
  isProcessing: boolean;
  onCloseModal: () => void;
  addTeamTemplateSize: (args: {
    teamId: string;
    size: TeamTemplateSizeInput;
    onSuccess?: () => void;
  }) => void;
}

interface AddTeamTemplateSizeModalState {
  form: SizeFormState;
  errors: SizeFormErrors;
  hasBlurred: boolean;
}

class AddTeamTemplateSizeModal extends Component<
  AddTeamTemplateSizeModalProps,
  AddTeamTemplateSizeModalState
> {
  state: AddTeamTemplateSizeModalState = {
    form: emptySizeFormState,
    errors: {},
    hasBlurred: false
  };

  handleChange = (patch: Partial<SizeFormState>) => {
    this.setState(prev => {
      const nextForm = { ...prev.form, ...patch };
      const errors = prev.hasBlurred ? validateSizeForm(nextForm) : prev.errors;
      return { form: nextForm, errors, hasBlurred: prev.hasBlurred };
    });
  };

  handleBlur = () => {
    this.setState(prev => ({
      hasBlurred: true,
      errors: validateSizeForm(prev.form)
    }));
  };

  canSave = () => {
    const errors = validateSizeForm(this.state.form);
    return isSizeFormValid(errors) && !this.props.isProcessing;
  };

  handleSave = () => {
    const errors = validateSizeForm(this.state.form);
    if (!isSizeFormValid(errors)) {
      this.setState({ errors, hasBlurred: true });
      return;
    }

    const { addTeamTemplateSize, teamId, onCloseModal } = this.props;
    addTeamTemplateSize({
      teamId,
      size: buildSizeInput(this.state.form),
      onSuccess: onCloseModal
    });
  };

  render() {
    const { isOpen, onCloseModal, isProcessing } = this.props;
    const { form, errors } = this.state;

    return (
      <Modal
        className={style.modal}
        isOpen={isOpen}
        contentLabel="Add Team Size"
        onRequestClose={onCloseModal}
        header="Add Team Size"
        buttonsClassName={style.modalButtons}
        buttons={[
          {
            name: "Cancel",
            theme: "gray",
            onClick: onCloseModal
          },
          {
            name: "Save",
            theme: "blueSolid",
            onClick: this.handleSave,
            disabled: !this.canSave(),
            isLoading: isProcessing
          }
        ]}
      >
        <TeamTemplateSizeForm
          form={form}
          errors={errors}
          onChange={this.handleChange}
          onFieldBlur={this.handleBlur}
        />
      </Modal>
    );
  }
}

export default AddTeamTemplateSizeModal;
